import React from "react";
import imgQr from "../../../assets/images/qr.png";
// import imageQr from "../../../myFolder/myImages/qr.png"; // Asegúrate de que la ruta sea correcta
import "./qrCode.scss"; // Archivo de estilos para el componente

const QrCode = () => {
  return (
    <div className="qrCodeContainer">
      <img src={imgQr} alt="CódigoQR" className="qrImage" />
    </div>
  );
};

export default QrCode;
